import React from 'react';
import './LinkSection.css';
import {NavLink} from "react-router-dom";

export default function LinkSection() {
    return (
        <section className="link-section-container">
            <ul className="link-section-list">
                <li className="link-card display-full-screen">
                    <h3>CHI SIAMO</h3>
                    <p>La nostra storia</p>
                    <NavLink to="/chi-siamo" className="link-card-button">SCOPRI</NavLink>
                </li>

                <li className="link-card">
                    <h3>IL NOSTRO MENU</h3>
                    <p>Scopri le nostre specialità</p>
                    <NavLink
                        to="/menu#menu-page-title"
                        className="link-card-button"
                    >
                        VEDI MENU
                    </NavLink>
                </li>

                <li className="link-card">
                    <h3>PRENOTA UN TAVOLO</h3>
                    <p>Riserva il tuo posto</p>
                    <a href="tel:+393513478565" className="link-card-button primary">
                        PRENOTA
                    </a>
                </li>
            </ul>
        </section>
    );
}
